import React from "react";
import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";

const Success: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Result
      status="success"
      title="Pago Enviado Exitosamente"
      subTitle="¡Todo listo! Hemos enviado un enlace de pago al firmante para que continúe con el proceso."
      extra={[
        <Button type="primary" key="console" onClick={() => navigate("/")}>
          Regresar
        </Button>,
      ]}
    />
  );
};

export default Success;
